import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8d128ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-with-text" }
const _hoisted_2 = { class: "line-with-text" }
const _hoisted_3 = ["href", "download"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Document',
  setup(__props) {

    const scan = (context:any, supportedExtensions:any) => {
        const keys = context.keys();

        return keys.reduce((result:any, key:any) => {
            const relativePath = key.substring(2); // 去掉 "./"
            const [title, nameWithExtension] = relativePath.split('/'); // 假设子目录名即为 title

            const [name, extension] = nameWithExtension.split('.');

            if (supportedExtensions.includes(extension.toLowerCase())) {
                // 初始化 title 对应的数据结构
                if (!result[title]) {
                    result[title] = {
                    title: title,
                    data: [],
                    };
                }

                // 读取模块内容
                const content = context(key).default;

                // 将数据添加到对应的 title 下
                result[title].data.push({
                    name: name,
                    extension: extension,
                    content: content,
                });
            }

            return result;
        }, {});
    }
    const supportedExtensions = ['pdf', 'docx', 'xlsx'];

    const assetsContext = require.context('@/assets/doc', true, /\.(pdf|docx|xlsx)$/);
    const scannedData = scan(assetsContext,supportedExtensions);
    const resultArray = Object.values(scannedData);

    // const assetsContext = require.context('@/assets/doc/', false, /\.(pdf)$/);

    // const assets = assetsContext.keys().map(key => {
    //     const fileName = key.substring(2);
    //     return {
    //         name: fileName,
    //         content: assetsContext(key).default,
    //     };
    // });

    // const assets = require.context('@/assets/doc/', false, /\.(pdf)$/).keys().map(key => {
    //     return {
    //         name: key.substring(2),
    //         content: require('@/assets/doc/' + key.substring(2)).default,
    //     };
    // });


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h5", _hoisted_1, [
      _createVNode(_component_el_divider, {
        class: "divider",
        "border-style": "double"
      }),
      _createTextVNode(" Document Archive "),
      _createVNode(_component_el_divider, {
        class: "divider",
        "border-style": "double"
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultArray), (r) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("h5", _hoisted_2, [
          _createVNode(_component_el_divider, {
            class: "divider",
            "border-style": "double"
          }),
          _createTextVNode(" " + _toDisplayString(r.title) + " ", 1),
          _createVNode(_component_el_divider, {
            class: "divider",
            "border-style": "double"
          })
        ]),
        _createVNode(_component_el_table, {
          data: r.data,
          stripe: "",
          border: "",
          style: _normalizeStyle([{ boxShadow: `var(--el-box-shadow-lighter)`}, {"width":"100%","font-family":"Lato, sans-serif","font-weight":"400","color":"#232946"}]),
          "max-height": "250"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "extension",
              label: "Type",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "Name"
            }),
            _createVNode(_component_el_table_column, {
              label: "Operations",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: scope.row.content,
                      download: scope.row.name,
                      style: {"text-decoration":"underline","color":"#232946"}
                    }, "Download", 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["data", "style"])
      ]))
    }), 256))
  ]))
}
}

})